export const experienceData = [
    {
        id: 1,
        company: 'Code:You',
        jobtitle: 'Technical Project Manager',
        startYear: '2023',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'Best One',
        jobtitle: 'Director of Information Technology',
        startYear: '2021',
        endYear: '2023'
    },
    {
        id: 3,
        company: 'Resideo',
        jobtitle: 'Software & Systems Engineer',
        startYear: '2018',
        endYear: '2021'
    },
]